import React from 'react';
import AvatarBase from './Base';

// TODO: Replace all using avatar/Base to avatar/User
const UserAvatar = props => {
    return <AvatarBase {...props} />;
};

export default React.memo(UserAvatar);
